import { PropsWithChildren } from 'react';
import { tw } from '../utils/tailwind';

// type Props = React.HTMLAttributes<HTMLButtonElement>;
type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

function styles({ disabled = false }: Props): string {
  return tw(
    'bg-primary',
    'transition-colors',
    'text-white',
    'text-base',
    'py-3',
    'px-12',
    'rounded-full',
    'focus:outline-none',
    {
      'hover:bg-primary-dark': !disabled,
      'opacity-50': disabled,
    }
  );
}

export function Button(props: PropsWithChildren<Props>) {
  return <button className={styles(props)} {...props} />;
}

type ButtonLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export function ButtonLink({
  href,
  children,
  ...rest
}: PropsWithChildren<ButtonLinkProps>) {
  return (
    <a href={href} className={styles({})} {...rest}>
      {children}
    </a>
  );
}
